import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CaseStudies from "./pages/CaseStudies";
import Products from "./pages/Products";
import TradieProPage from "./pages/TradieProPage";
import RosteringPage from "./pages/RosteringPage";
import { Toaster } from "./components/ui/sonner";

const AdminRoute = () => {
  const [authenticated, setAuthenticated] = useState(
    () => !!sessionStorage.getItem('admin_token')
  );

  if (!authenticated) {
    return <AdminLogin onLogin={() => setAuthenticated(true)} />;
  }
  return <AdminDashboard />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminRoute />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/products" element={<Products />} />
          <Route path="/tradiepro" element={<TradieProPage />} />
          <Route path="/rostering" element={<RosteringPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
